import { Box } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../components/v3";
import { formatBalance, getBalanceColor } from "../../utils";

/**
 * Route paths for the employee module.
 * Single source of truth — reuse these instead of hard-coding `/employees...` or `/employee...` strings.
 */
export const EMPLOYEE_ROUTES = {
  root: "/employees",
  details: "/employee/:id",
  addIncentive: "/employee/add-incentive",
} as const;

export const EmployeeTableColumns = [
  { field: "sl", headerName: "Sl No", flex: 0.4, sortable: false },
  {
    field: "name",
    headerName: "Name",
    flex: 1.5,
    sortable: true,
  },
  {
    field: "designation",
    headerName: "Designation",
    flex: 1.5,
    sortable: false,
  },
  {
    field: "primaryPhone",
    headerName: "Phone Number",
    flex: 1.5,
    sortable: false,
  },
  {
    field: "salary",
    headerName: "salary",
    flex: 1.5,
    sortable: true,
  },
  {
    field: "formattedBalance",
    headerName: "Balance",
    flex: 1.5,
    sortable: false,
    renderCell: (params) => {
      const value = params.value;
      const rawBalance = params.row.balance;
      return <Box sx={{ color: getBalanceColor(rawBalance), display: "flex", alignItems: "center" }}>{value}</Box>;
    },
  },
];

/**
 * Route paths for the employee module.
 * Single source of truth — reuse these instead of hard-coding `/employees...` or `/employee...` strings.
 */
export const getStatementTableColumns = (
  handleActions,
  hasEditAttendance,
  hasDeleteAttendance,
  hasEditSalary,
  hasDeleteSalary,
) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.75, sortable: false },
    { field: "date", headerName: "Date", flex: 1, sortable: true, sortingOrder: ["desc", "asc", null] },
    {
      field: "description",
      headerName: "description",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "amount",
      headerName: "Salary / Pay Out",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;
        const value = params.value;
        if (!value) return "-";

        const color = row?.type ? "green" : "red";
        return <span style={{ color: color, display: "flex", alignItems: "center", gap: 4 }}>₹ {Number(value).toFixed(2)}</span>;
      },
    },
    { field: "accountName", headerName: "From Account", flex: 1.5, sortable: false },
    // { field: "balance", headerName: "Balance", flex: 1 },
  ];

  if (hasEditAttendance || hasDeleteAttendance || hasEditSalary || hasDeleteSalary) {
    headers.push({
      field: "actions",
      headerName: "Action",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const { type } = params.row;
        const actions = [];

        if (!type) {
          if (hasEditAttendance) {
            actions.push({
              icon: Edit,
              type: "edit",
              label: "Edit",
              onClick: handleActions,
            });
          }

          if (hasDeleteAttendance) {
            actions.push({
              icon: Delete,
              type: "delete",
              label: "Delete",
              onClick: handleActions,
            });
          }
        } else {
          if (hasEditSalary) {
            actions.push({
              icon: Edit,
              type: "edit",
              label: "Edit",
              onClick: handleActions,
            });
          }

          if (hasDeleteSalary) {
            actions.push({
              icon: Delete,
              type: "delete",
              label: "Delete",
              onClick: handleActions,
            });
          }
        }

        return <TableActions item={params} actions={actions} />;
      },
    });
  }
  return headers;
};
